import React, {useState} from 'react'
import bn from "../../../utils/bemnames"
import {getDefaultCompetitorImage} from '../../../utils/competitor'
import {getInternalLinks, IInternalLinks} from '../../../utils/internal-links'
import {
  EventPositions,
  IEventCompetitor,
  EventTypes
} from '../../../utils/types'
import ImgWithDefault from '../../ImgWithDefault'

import CountryFlag from "../../CountryFlag"

const bem = bn.create('event-competitor')

interface IProps {
  eventCompetitor: IEventCompetitor | null
  sportId: number
  isMobile: boolean
  eventType: string
}

const EventCompetitor: React.FC<IProps> = (props) => {
  const {
    eventCompetitor,
    isMobile,
    eventType
  } = props;

  const [internalLinks] = useState<IInternalLinks|null>(getInternalLinks());

  return (
    <div className={`${bem.b()} ${isMobile ? bem.m('mobile') : ''}`}>
      {eventCompetitor && <>
        {(eventCompetitor.position === EventPositions.away) && (
          <div className={bem.m('away')}>
            {eventType === 'event_1v1' && (
              <div className={bem.e('logo')}>
                {internalLinks && internalLinks.awayCompetitorPageLink ? (
                  <a href={internalLinks.awayCompetitorPageLink}>
                    {eventCompetitor?.competitor?.isNationalTeam && eventCompetitor?.competitor?.regionName ? (
                      <CountryFlag
                        regionName={eventCompetitor.competitor?.regionName}
                        className={bem.e('competitor-logo')}
                      />
                    ) : (
                      <ImgWithDefault
                        src={eventCompetitor.competitor?.logoUrl ?? ''}
                        alt={eventCompetitor.competitor?.trName ?? ''}
                        defaultSrc={getDefaultCompetitorImage(eventCompetitor.competitor?.sportId)}
                        className={bem.e('competitor-logo')}
                      />
                    )}
                  </a>
                  ) :
                  (
                    <>
                      {eventCompetitor?.competitor?.isNationalTeam && eventCompetitor?.competitor?.regionName ? (
                        <CountryFlag
                          regionName={eventCompetitor.competitor?.regionName}
                          className={bem.e('competitor-logo')}
                        />
                      ) : (
                        <ImgWithDefault
                          src={eventCompetitor.competitor?.logoUrl ?? ''}
                          alt={eventCompetitor.competitor?.trName ?? ''}
                          defaultSrc={getDefaultCompetitorImage(eventCompetitor.competitor?.sportId)}
                          className={bem.e('competitor-logo')}
                        />
                      )}
                    </>
                  )
                }
              </div>
            )}

            {!isMobile && EventTypes.event_1v1 && (
              <div className={`${bem.e('name')} ${isMobile ? bem.e('name--mobile') : ''}`}>
                {internalLinks && internalLinks.awayCompetitorPageLink
                  ? <a href={internalLinks.awayCompetitorPageLink}>{eventCompetitor.competitor?.trName}</a>
                  : <span>{eventCompetitor.competitor?.trName}</span>
                }
              </div>
            )}
            {isMobile && eventType === 'event_2v2' && (
              <div className={`${bem.e('name')} ${isMobile ? bem.e('name--mobile') : ''}`}>
                {internalLinks && internalLinks.awayCompetitorPageLink
                  ? <a href={internalLinks.awayCompetitorPageLink}>{eventCompetitor.competitor?.trName}</a>
                  : <span>{eventCompetitor.competitor?.trName}</span>
                }
              </div>
            )}
          </div>
        )}
        {(eventCompetitor.position === EventPositions.awaySecond) && (
          <div className={bem.m('away-second')}>
            {!isMobile && <div className={`${bem.e('name')} ${isMobile ? bem.e('name--mobile') : ''}`}>
              {internalLinks && internalLinks.awaySecondCompetitorPageLink
                ? <a href={internalLinks.awaySecondCompetitorPageLink}>{eventCompetitor.competitor?.trName}</a>
                : <span>{eventCompetitor.competitor?.trName}</span>
              }
            </div>}

            {isMobile && EventTypes.event_2v2 && (
              <div className={`${bem.e('name')} ${isMobile ? bem.e('name--mobile') : ''}`}>
                {internalLinks && internalLinks.awaySecondCompetitorPageLink
                  ? <a href={internalLinks.awaySecondCompetitorPageLink}>{eventCompetitor.competitor?.trName}</a>
                  : <span>{eventCompetitor.competitor?.trName}</span>
                }
              </div>
            )}
          </div>
        )}
        {eventCompetitor.position === EventPositions.home && (
          <div className={bem.m('home')}>
            {!isMobile && <div className={`${bem.e('name')} ${isMobile ? bem.e('name--mobile') : ''}`}>
              {internalLinks && internalLinks.homeCompetitorPageLink
                ? <a href={internalLinks.homeCompetitorPageLink}>{eventCompetitor.competitor?.trName}</a>
                : <span>{eventCompetitor.competitor?.trName}</span>
              }
            </div>}
            {eventType === 'event_1v1' && (
              <div className={bem.e('logo')}>
                {internalLinks && internalLinks.homeCompetitorPageLink ? (
                  <a href={internalLinks.homeCompetitorPageLink}>
                    {eventCompetitor?.competitor?.isNationalTeam && eventCompetitor?.competitor?.regionName ? (
                      <CountryFlag
                        regionName={eventCompetitor.competitor?.regionName}
                        className={bem.e('competitor-logo')}
                      />
                    ) : (
                      <ImgWithDefault
                        src={eventCompetitor.competitor?.logoUrl ?? ''}
                        alt={eventCompetitor.competitor?.trName ?? ''}
                        defaultSrc={getDefaultCompetitorImage(eventCompetitor.competitor?.sportId)}
                        className={bem.e('competitor-logo')}
                      />
                    )}
                  </a>
                ) : (
                  <>
                    {eventCompetitor?.competitor?.isNationalTeam && eventCompetitor?.competitor?.regionName ? (
                      <CountryFlag
                        regionName={eventCompetitor.competitor?.regionName}
                        className={bem.e('competitor-logo')}
                      />
                    ) : (
                      <ImgWithDefault
                        src={eventCompetitor.competitor?.logoUrl ?? ''}
                        alt={eventCompetitor.competitor?.trName ?? ''}
                        defaultSrc={getDefaultCompetitorImage(eventCompetitor.competitor?.sportId)}
                        className={bem.e('competitor-logo')}
                      />
                    )}
                  </>
                )}
              </div>
            )}

            {isMobile && eventType === 'event_2v2' && (
              <div className={`${bem.e('name')} ${isMobile ? bem.e('name--mobile') : ''}`}>
                {internalLinks && internalLinks.homeCompetitorPageLink
                  ? <a href={internalLinks.homeCompetitorPageLink}>{eventCompetitor.competitor?.trName}</a>
                  : <span>{eventCompetitor.competitor?.trName}</span>
                }
              </div>
            )}
          </div>
        )}
        {eventCompetitor.position === EventPositions.homeSecond && (
          <div className={bem.m('home-second')}>
            {!isMobile && <div className={`${bem.e('name')} ${isMobile ? bem.e('name--mobile') : ''}`}>
              {internalLinks && internalLinks.homeSecondCompetitorPageLink
                ? <a href={internalLinks.homeSecondCompetitorPageLink}>{eventCompetitor.competitor?.trName}</a>
                : <span>{eventCompetitor.competitor?.trName}</span>
              }
            </div>}

            {isMobile && EventTypes.event_2v2 && (
              <div className={`${bem.e('name')} ${isMobile ? bem.e('name--mobile') : ''}`}>
                {internalLinks && internalLinks.homeSecondCompetitorPageLink
                  ? <a href={internalLinks.homeSecondCompetitorPageLink}>{eventCompetitor.competitor?.trName}</a>
                  : <span>{eventCompetitor.competitor?.trName}</span>
                }
              </div>
            )}
          </div>
        )}
      </>
      }
    </div>
  )
}

export default EventCompetitor;
